
import _ from "lodash";
import state from "../state";

import { CHANNEL_VARIABLE_STATE_CHANGE } from "@ambifi/ambifi-lib-calculator";
const PROP_VARIABLES = "variables";
const VARIABLES_PATH = ["activity", PROP_VARIABLES];

export function setValueIfHasId(item, value, publish = true) {
	if (item && item.id) {
		return setVariable(item.id, value, publish);
	}
	return false;
}

export function setVariable(variableName, value, publish = true) {
	if (variableName && variableName.id) {
		variableName = variableName.id;
	} else if (!_.isString(variableName)) {
		throw new Error(`The variable parameter must either be a string describing the variable name or an Object with an id property. Got: ${variableName}`);
	}

	const result = {
		[variableName]: {
			id: variableName,
			value
		}
	};
	const variablePath = _.concat(VARIABLES_PATH, variableName);
	const existingState = state.get(variablePath);
	// Baobab doesn't care about the state update if the value is the same but we need to prevent
	// communicating changes when there aren't any
	if (!existingState || existingState.value !== value || (_.isArray(existingState.value) && _.isArray(value))) {
		console.log(new Date().getTime(), "IFTTT SET VARIABLE:", variableName, value);
		state.set(variablePath, result[variableName]);
		if (publish) {
			global.pubSubProvider.publish(CHANNEL_VARIABLE_STATE_CHANGE, result);
		}
		return result;
	}
	return null;
}

export function getVariables() {
	return state.get(VARIABLES_PATH);
}